import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/Layout";
import api, { API } from "@/lib/api";
import Select from "@/components/Select";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";

export default function Reports() {
  const { has } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [empls, setEmpls] = useState([]);
  const [units, setUnits] = useState([]);
  const [emplFilter, setEmplFilter] = useState("");
  const [unitFilter, setUnitFilter] = useState("");

  useEffect(() => {
    // Notă: /users e admin/hr-only — managerul nu are acces, de-asta filtrul de
    // raport de muncă folosește e.user_name (deja inclus în /mdm/employments).
    Promise.all([api.get("/config"), api.get("/mdm/employments"), api.get("/mdm/org-units")])
      .then(([c,e,o]) => { setCfg(c.data); setEmpls(e.data); setUnits(o.data);
        setYear(c.data.planning_year || new Date().getFullYear()); });
  }, []);

  const buildQuery = (extra = "") => {
    const params = new URLSearchParams();
    params.set("year", year);
    if (emplFilter) params.set("employment_id", emplFilter);
    if (unitFilter) params.set("org_unit_id", unitFilter);
    return `${extra}?${params.toString()}`;
  };
  const dl = async (path, filename) => {
    const r = await fetch(`${API}${path}`, { credentials: "include" });
    if (!r.ok) { alert("Eroare la generarea raportului"); return; }
    const b = await r.blob();
    const a = document.createElement("a"); a.href = URL.createObjectURL(b);
    a.download = filename; a.click();
  };

  return (
    <>
      <PageHeader title="Rapoarte" subtitle={`Anul de programare: ${cfg?.planning_year || year}`}
        actions={
          <Select className="select" style={{width:100}} value={year} onChange={e=>setYear(parseInt(e.target.value))} data-testid="rpt-year">
            {[year-1, year, year+1].map(y=><option key={y}>{y}</option>)}
          </Select>} />

      {/* Filtre */}
      <div className="card" style={{padding:16, marginBottom:20}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr auto",gap:12,alignItems:"end"}}>
          <div><label className="label">Filtru: Structură organizatorică</label>
            <Select className="select" value={unitFilter} onChange={e=>{setUnitFilter(e.target.value); setEmplFilter("");}} data-testid="filter-unit">
              <option value="">Toate structurile</option>
              {units.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
            </Select></div>
          <div><label className="label">Filtru: Raport de muncă</label>
            <Select className="select" value={emplFilter} onChange={e=>{setEmplFilter(e.target.value); setUnitFilter("");}} data-testid="filter-empl">
              <option value="">Toate rapoartele</option>
              {empls.filter(e=>!unitFilter||e.org_unit_id===unitFilter).map(e=>(
                <option key={e.id} value={e.id}>{e.marca} · {e.user_name || ""}</option>
              ))}
            </Select></div>
          <button className="btn btn-secondary" onClick={()=>{setEmplFilter(""); setUnitFilter("");}}>Reset filtre</button>
        </div>
      </div>

      <div className="grid-3">
        <ReportCard
          title={`Raport CO disponibile ${year}`}
          desc={`Situația privind numărul de zile de CO la care are dreptul personalul în anul ${year}. Format legal cu semnături "Întocmit" și "Avizat".`}
          actions={<>
            <button className="btn btn-secondary" onClick={()=>dl(buildQuery("/planco/reports/co-available/excel"), `raport_co_disponibile_${year}.xlsx`)} data-testid="dl-co-avail-xlsx" {...lock(has("reports.co_available_excel"))}>Excel</button>
            <button className="btn btn-primary" onClick={()=>dl(buildQuery("/planco/reports/co-available/pdf"), `raport_co_disponibile_${year}.pdf`)} data-testid="dl-co-avail-pdf" {...lock(has("reports.co_available_pdf"))}>PDF</button>
          </>} />
        <ReportCard
          title={`Programare CO ${year}`}
          desc={`Programarea concediului de odihnă pe trimestre, cu semnătura salariatului și conducătorului structurii. Aprobatorul configurat în antet.`}
          actions={<>
            <button className="btn btn-secondary" onClick={()=>dl(buildQuery("/planco/reports/programming/excel"), `programare_co_${year}.xlsx`)} data-testid="dl-prog-xlsx" {...lock(has("reports.programming_excel"))}>Excel</button>
            <button className="btn btn-primary" onClick={()=>dl(buildQuery("/planco/reports/programming/pdf"), `programare_co_${year}.pdf`)} data-testid="dl-prog-pdf" {...lock(has("reports.programming_pdf"))}>PDF</button>
          </>} />
        <ReportCard
          title="Solduri concediu"
          desc="Soldurile detaliate pe raport de muncă (CO an programare, reportat, condiții, alte)."
          actions={<>
            <button className="btn btn-secondary" onClick={()=>{
              const p = new URLSearchParams();
              if (emplFilter) p.set("employment_id", emplFilter);
              if (unitFilter) p.set("org_unit_id", unitFilter);
              dl(`/planco/reports/balances/excel?${p.toString()}`, "solduri_co.xlsx");
            }} data-testid="dl-bal-xlsx" {...lock(has("reports.balances_excel"))}>Excel</button>
          </>} />
      </div>
    </>
  );
}

function ReportCard({ title, desc, actions }) {
  return <div className="card fade-up" style={{padding:22}}>
    <h3 style={{margin:"0 0 8px",fontSize:15,fontWeight:700,color:"var(--navy)"}}>{title}</h3>
    <p style={{color:"#64748B",fontSize:13,minHeight:56, lineHeight:1.5}}>{desc}</p>
    <div style={{display:"flex",gap:8,marginTop:10}}>{actions}</div>
  </div>;
}
